import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=b0f24c50&scoped=true"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"
import style0 from "./ButtonClose.vue?vue&type=style&index=0&id=b0f24c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f24c50",
  null
  
)

export default component.exports